var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-runtime-template',{attrs:{"template":_vm.includeTemplate}}),_vm._v(" "),(_vm.visible)?_c('div',[_c('v-runtime-template',{attrs:{"template":_vm.includeYoutubeHtml}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ab1d4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/layouts/WepForum.vue
// module id = MLcB
// module chunks = 1